import domain from "./DomainService";

/**
 * Generate a short-lived Affonso embed token so the Refer & Earn iframe
 * can be rendered for the logged in user.
 *
 * Uses JWT token to identify user
 * @return {Promise}
 */
export default function GetAffonsoEmbedToken() {
  const token = localStorage.getItem("token");
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
  };
  return fetch(domain() + "affonso/embed-token", options);
}
